import { tv } from 'tailwind-variants'

export const mediaVariants = tv({
  slots: {
    container: 'w-full my-[80px] text-mega flex items-center text-center justify-center',
    image: 'max-h-[350px] w-full rounded-t-mili object-cover hover:cursor-pointer',
    video: 'max-h-[350px] w-full rounded-t-mili object-contain',
    documentContainer: 'flex flex-col space-y-mili mb-mili overflow-none',
    document: 'max-h-[350px] w-full rounded-t-mili border-none'
  },
  variants: {
    source: {
      CLIENT: {
        image: 'rounded-br-mili',
        video: 'rounded-br-mili',
        document: 'rounded-br-mili'
      },
      PRODUCT: {
        image: 'rounded-bl-mili',
        video: 'rounded-bl-mili',
        document: 'rounded-bl-mili'
      }
    }
  }
})
